import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { EmployerFormFields } from 'src/@types';
import { Grid, GridItem, Heading, HStack } from '@chakra-ui/react';
import { employerStatementFormFields } from '../config';
import { validationMessages } from 'src/components/shared/validation/validation-messages';
import { DynamicInput } from 'src/components/shared/form-elements';

export const EmployerStatementIncomeSection = ({
  heading,
  register,
  errors
}: {
  heading: string;
  register: UseFormRegister<EmployerFormFields>;
  errors: FieldErrors<EmployerFormFields>;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)'
        }}
        gap={4}>
        <DynamicInput
          id={employerStatementFormFields.jaarsalaris.fieldName}
          label={employerStatementFormFields.jaarsalaris.label}
          type={employerStatementFormFields.jaarsalaris.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.jaarsalaris.tooltip}
          error={errors.jaarsalaris}
          hint={employerStatementFormFields.jaarsalaris.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.vakantieToeslag.fieldName}
          label={employerStatementFormFields.vakantieToeslag.label}
          type={employerStatementFormFields.vakantieToeslag.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.vakantieToeslag.tooltip}
          error={errors.vakantieToeslag}
          hint={employerStatementFormFields.vakantieToeslag.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.onregelmatigheidsToeslag.fieldName}
          label={employerStatementFormFields.onregelmatigheidsToeslag.label}
          type={employerStatementFormFields.onregelmatigheidsToeslag.type}
          tooltip={employerStatementFormFields.onregelmatigheidsToeslag.tooltip}
          error={errors.onregelmatigheidsToeslag}
          hint={employerStatementFormFields.onregelmatigheidsToeslag.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.vaste13eMaand.fieldName}
          label={employerStatementFormFields.vaste13eMaand.label}
          type={employerStatementFormFields.vaste13eMaand.type}
          tooltip={employerStatementFormFields.vaste13eMaand.tooltip}
          error={errors.vaste13eMaand}
          hint={employerStatementFormFields.vaste13eMaand.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.provisie.fieldName}
          label={employerStatementFormFields.provisie.label}
          type={employerStatementFormFields.provisie.type}
          tooltip={employerStatementFormFields.provisie.tooltip}
          error={errors.provisie}
          hint={employerStatementFormFields.provisie.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.eindejaarsUitkering.fieldName}
          label={employerStatementFormFields.eindejaarsUitkering.label}
          type={employerStatementFormFields.eindejaarsUitkering.type}
          tooltip={employerStatementFormFields.eindejaarsUitkering.tooltip}
          error={errors.eindejaarsUitkering}
          hint={employerStatementFormFields.eindejaarsUitkering.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.overwerk.fieldName}
          label={employerStatementFormFields.overwerk.label}
          type={employerStatementFormFields.overwerk.type}
          tooltip={employerStatementFormFields.overwerk.tooltip}
          error={errors.overwerk}
          hint={employerStatementFormFields.overwerk.hint}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.extraFlexibleBudget.fieldName}
          label={employerStatementFormFields.extraFlexibleBudget.label}
          type={employerStatementFormFields.extraFlexibleBudget.type}
          tooltip={employerStatementFormFields.extraFlexibleBudget.tooltip}
          error={errors.extraFlexibleBudget}
          hint={employerStatementFormFields.extraFlexibleBudget.hint}
          register={register}
        />

        <GridItem>
          <HStack w={'100%'} align={'top'}>
            <DynamicInput
              id={employerStatementFormFields.incomeCustom1Title.fieldName}
              label={employerStatementFormFields.incomeCustom1Title.label}
              type={employerStatementFormFields.incomeCustom1Title.type}
              tooltip={employerStatementFormFields.incomeCustom1Title.tooltip}
              error={errors.incomeCustom1Title}
              hint={employerStatementFormFields.incomeCustom1Title.hint}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.incomeCustom1Amount.fieldName}
              label={employerStatementFormFields.incomeCustom1Amount.label}
              type={employerStatementFormFields.incomeCustom1Amount.type}
              tooltip={employerStatementFormFields.incomeCustom1Amount.tooltip}
              error={errors.incomeCustom1Amount}
              hint={employerStatementFormFields.incomeCustom1Amount.hint}
              register={register}
            />
          </HStack>
          <HStack w={'100%'} align={'top'}>
            <DynamicInput
              id={employerStatementFormFields.incomeCustom2Title.fieldName}
              label={employerStatementFormFields.incomeCustom2Title.label}
              type={employerStatementFormFields.incomeCustom2Title.type}
              tooltip={employerStatementFormFields.incomeCustom2Title.tooltip}
              error={errors.incomeCustom2Title}
              hint={employerStatementFormFields.incomeCustom2Title.hint}
              register={register}
            />

            <DynamicInput
              id={employerStatementFormFields.incomeCustom2Amount.fieldName}
              label={employerStatementFormFields.incomeCustom2Amount.label}
              type={employerStatementFormFields.incomeCustom2Amount.type}
              tooltip={employerStatementFormFields.incomeCustom2Amount.tooltip}
              error={errors.incomeCustom2Amount}
              hint={employerStatementFormFields.incomeCustom2Amount.hint}
              register={register}
            />
          </HStack>
        </GridItem>
      </Grid>
    </>
  );
};
